var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',_vm._g(_vm._b({ref:"calendar",staticClass:"ts-date-picker",attrs:{"is-inline":"","theme":_vm.theme}},'DatePicker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }